<div cdkDrag cdkDragBoundary="html" cdkDragRootElement=".cdk-overlay-pane" [class.folded]="folded" class="mat-typography dialog-content">
  <pm-foldable-dialog-title mat-dialog-title (foldedChange)="folded = $event">{{'dialog.permissions-list.title' | translate}}<mat-spinner matSuffix [class.proman-visible]="loading" [diameter]="18"></mat-spinner></pm-foldable-dialog-title>
  <mat-dialog-content>
    <table mat-table class="pm-show-active" [dataSource]="dataSource">
      <ng-container matColumnDef="label">
        <th mat-header-cell class="proman-search-header" *matHeaderCellDef> {{'dialog.owner-list.table.label' |
          translate}}
        </th>
        <td mat-cell *matCellDef="let element" [title]="element.label"> {{element.label}}
        </td>
      </ng-container>

      <ng-container matColumnDef="path">
        <th mat-header-cell *matHeaderCellDef> {{'dialog.owner-list.table.path' | translate}}</th>
        <td mat-cell class="proman-search-path" *matCellDef="let element"
        [title]="element.path"> {{element.path}}</td>
      </ng-container>

      <ng-container matColumnDef="users">
        <th mat-header-cell class="proman-search-header" *matHeaderCellDef> {{'dialog.permissions-list.table.groups' |
          translate}}
        </th>
        <td mat-cell class="hide-active" *matCellDef="let element">
          @for (group of element.extraData.groupPerms; track group) {
            <div>
              {{group.groupName}}
              @if (group.writePermission) {
                <span>&nbsp;({{"dialog.permissions-list.table.edit" | translate}})</span>
              }
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="groups">
        <th mat-header-cell class="proman-search-header" *matHeaderCellDef> {{'dialog.permissions-list.table.users' |
          translate}}
        </th>
        <td mat-cell class="hide-active" *matCellDef="let element">
          @for (user of element.extraData.userPerms; track user) {
            <div>
              {{user.userName}}
              <small>{{fullname(user)}}</small>
              @if (user.writePermission) {
                <span>&nbsp;({{"dialog.permissions-list.table.edit" | translate}})</span>
              }
            </div>
          }
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="navigateToNode(row)"
      [class.active]="row.id === activeSearchElement"></tr>
    </table>
  </mat-dialog-content >
</div>
